import { render, staticRenderFns } from "./LogsAjustesManuaisTabelasDataTable.vue?vue&type=template&id=d1a373ec&scoped=true&"
import script from "./LogsAjustesManuaisTabelasDataTable.vue?vue&type=script&lang=js&"
export * from "./LogsAjustesManuaisTabelasDataTable.vue?vue&type=script&lang=js&"
import style0 from "./LogsAjustesManuaisTabelasDataTable.vue?vue&type=style&index=0&id=d1a373ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a373ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VSimpleTable,VTextField})
